// extracted by mini-css-extract-plugin
module.exports = {"card":"FeaturedConditionCard_card__dRK7t","intro":"FeaturedConditionCard_intro__2R6O5"};